import I18N from '@leverege/i18n';
import { GlobalState } from '@leverege/ui-redux';
import { Config } from '@leverege/plugin';
import { Auth } from '@leverege/api-redux';
import { History } from '@leverege/molten-core';
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.screens.account.AccountLink');
const path = '/account';
export default {
  id: 'link.desktop.Account',
  matches: {
    use: 'userBar',
    client: 'Main'
  },
  layout: {
    group: ['user'],
    sort: 'account.setting.a',
    sectionName: tf('sectionName')
  },
  handles: context => {
    return Auth.getProfile(GlobalState.get().auth) != null && !context.mobile;
  },
  appearance: ({
    context,
    action
  }) => {
    return {
      get name() {
        return t('name');
      },
      get icon() {
        return tIcon('icon') || Config.get('Main', 'accountIcon', 'https://molten-ui-assets.storage.googleapis.com/settings-account.png');
      }
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps: {
        dispatch
      }
    } = context;
    dispatch(History.push(path));
  }
};